export default {
  CUSTOMER_DOCUMENT_POCKET_REPOSITORY: Symbol.for('CUSTOMER_DOCUMENT_POCKET_REPOSITORY'),
  UPDATE_CUSTOMER_DOCUMENT_POCKET_BANK_STATEMENT_COMMAND: Symbol.for('UPDATE_CUSTOMER_DOCUMENT_POCKET_BANK_STATEMENT_COMMAND'),
  UPDATE_CUSTOMER_DOCUMENT_POCKET_PROOF_ADDRESS_COMMAND: Symbol.for('UPDATE_CUSTOMER_DOCUMENT_POCKET_PROOF_ADDRESS_COMMAND'),
};
